<template>
    <div class="navbar">
        <div class="backbtn" @click="goBack"><span class="iconfont icon-fanhui"></span></div>
        <div class="title">{{navtitle}}</div>
        <div>
            <div class="title-mine" @click="gomine"><span class="iconfont icon-wode"></span></div>
            <div class="title-home" @click="gohome"><span class="iconfont icon-home"></span></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        navtitle:String,
    },
    data(){
        return{
            
        }
    },
    methods: {
        goBack () {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        gomine(){
            this.$router.push('./mine')
        },
        gohome(){
            this.$router.push('./home')
        }
    }
}
</script>
<style lang="scss" scoped>
.navbar{
    display: flex;
    justify-content: space-between;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    padding: 0 30px;
    padding-left: 0;
    width: 100vw;
    height: 84px;
    text-align: center;
    line-height: 88px;
    font-size: 36px;
    background-color: #fff;
    .backbtn{
        float: left;
        width: 80px;
        height: 80px;
        span{
            font-size: 35px;
            font-weight: 700;
            color: #555;
        }
    }
    .title-home{
        float: right;
        width: 60px;
        height: 60px;
        span{
            font-size: 38px;
            font-weight: 700;
            color: #555;
        }
    }
    .title-mine{
        float: right;
        width: 60px;
        height: 60px;
        span{
            font-size: 35px;
            font-weight: 700;
            color: #555;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/basecomponents/navbar.vue